/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OpportunityLane
 */
export interface OpportunityLane {
  /**
   *
   * @type {string}
   * @memberof OpportunityLane
   */
  pickup: string;
  /**
   *
   * @type {string}
   * @memberof OpportunityLane
   */
  delivery: string;
  /**
   *
   * @type {number}
   * @memberof OpportunityLane
   */
  shipmentCount: number;
  /**
   *
   * @type {number}
   * @memberof OpportunityLane
   */
  sharePercentage: number;
  /**
   * Whether this lane falls inside the carrier's service area.
   * @type {boolean}
   * @memberof OpportunityLane
   */
  covered?: boolean;
}

/**
 * Check if a given object implements the OpportunityLane interface.
 */
export function instanceOfOpportunityLane(
  value: object,
): value is OpportunityLane {
  if (!("pickup" in value) || value["pickup"] === undefined) return false;
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  if (!("sharePercentage" in value) || value["sharePercentage"] === undefined)
    return false;
  return true;
}

export function OpportunityLaneFromJSON(json: any): OpportunityLane {
  return OpportunityLaneFromJSONTyped(json, false);
}

export function OpportunityLaneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityLane {
  if (json == null) {
    return json;
  }
  return {
    pickup: json["pickup"],
    delivery: json["delivery"],
    shipmentCount: json["shipmentCount"],
    sharePercentage: json["sharePercentage"],
    covered: json["covered"] == null ? undefined : json["covered"],
  };
}

export function OpportunityLaneToJSON(json: any): OpportunityLane {
  return OpportunityLaneToJSONTyped(json, false);
}

export function OpportunityLaneToJSONTyped(
  value?: OpportunityLane | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pickup: value["pickup"],
    delivery: value["delivery"],
    shipmentCount: value["shipmentCount"],
    sharePercentage: value["sharePercentage"],
    covered: value["covered"],
  };
}
